import { ArticleCaption } from '@/core/components/ArticleCaption';
import {
  DataType,
  Nullable,
} from '@/core/interfaces/common';
import { Chip } from '@/core/components/Chip';

import {
  ArticleTopic as ArticleTopicType,
  Author as AuthorType,
} from '@/features/Articles/Articles.types';

import { getBackendImage } from '@/utils/helpers';

import {
  Author,
  AuthorHelpertext,
  AuthorName,
  AuthorSection,
  AuthorWrapper,
  Avatar,
  AvatarImage,
  BannerImage,
  DetailsWrapper,
  Header,
  ImageWrapper,
  SubHeader,
  TopicsWrapper,
  Wrapper,
} from './Banner.styles';

type BannerProps = {
  alt: string;
  author?: AuthorType;
  image?: string;
  title: string;
  topics: Array<DataType<ArticleTopicType>>;
  subtitle: string;
  readingTime: Nullable<number>;
  date: string;
};

export const Banner = ({
  alt,
  author,
  date,
  image,
  title,
  topics,
  readingTime,
  subtitle,
}: BannerProps) => (
  <Wrapper>
    <ImageWrapper>
      <BannerImage
        src={image}
        alt={alt}
      />
    </ImageWrapper>
    <DetailsWrapper>
      <Header>{title}</Header>
      <SubHeader>{subtitle}</SubHeader>
      <ArticleCaption
        date={date}
        readingTime={readingTime}
      />
      {!!topics.length && (
        <TopicsWrapper>
          {topics.map(topic => (
            <Chip>
              {topic.attributes.name}
            </Chip>
          ))}
        </TopicsWrapper>
      )}
      {author && (
        <AuthorSection>
          <AuthorWrapper>
            <Avatar>
              <AvatarImage
                src={getBackendImage(author.image?.data?.attributes.url)}
                alt={author.image?.data?.attributes.alternativeText ||
                  `${author.name} avatar`}
              />
            </Avatar>
            <Author>
              <AuthorName>
                {author?.name}
              </AuthorName>
              <AuthorHelpertext>
                {author.helper}
              </AuthorHelpertext>
            </Author>
          </AuthorWrapper>
        </AuthorSection>
      )}
    </DetailsWrapper>
  </Wrapper>
);
